/**
 * Google Docs outline on nested `<ol>`: 1. → a. → i., then repeat.
 * Specificity of `ol ol` beats a descendant `ol { list-style: decimal }`.
 */
export const ORDERED_LIST_NEST_STYLE_CLASSES: string =
  "[&_ol]:list-decimal [&_ol_ol]:list-[lower-alpha] [&_ol_ol_ol]:list-[lower-roman] " +
  "[&_ol_ol_ol_ol]:list-decimal [&_ol_ol_ol_ol_ol]:list-[lower-alpha] [&_ol_ol_ol_ol_ol_ol]:list-[lower-roman]";
